"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeTaggingEventPayload = composeTaggingEventPayload;
var _services = require("../services");
function composeTaggingEventPayload(taggingEventData) {
  if (!_services.Services.analytics.IS_TAGGING_ENABLED) return null;
  const taggingEvents = _services.Services.analytics.composeTaggingEvents(taggingEventData);
  const taggingEvent = taggingEvents[taggingEventData.eventName];
  if (!taggingEvent) return null;
  const {
    taggingId,
    taggingType,
    ...rest
  } = taggingEvent;
  return {
    taggingId,
    taggingType,
    taggingValue: JSON.parse(JSON.stringify(rest))
  };
}